import { CloseOutlined } from '@ant-design/icons';
import React, { useReducer, useRef, useState } from 'react';
import './index.less';
import classNames from 'classnames';
import { Filter, Site } from 'patternx-svg';
import { Dropdown, Input, Menu, Button, Tooltip } from 'antd';
import { Sort, Search } from 'patternx-svg';
import { debounce } from 'lodash';
import { List, Card } from 'patternx-svg';

interface ISearchRadioState {
  active?: number | string;
  onChange?: Function;
}

export const SearchRadio = React.memo((props: ISearchRadioState) => {
  const [active, setActive] = useState(props?.active);

  const _handlerChangeItem = (index: number | string) => {
    setActive(index);
    props.onChange?.call(null, index);
  };

  const checkList = [
    { active: 0, child: <Card size={20} /> },
    { active: 1, child: <List size={20} /> },
  ];

  return (
    <div className="search_radio_box search_item">
      {checkList.map((item) => {
        return (
          <div
            key={item.active}
            className={classNames('center', 'search_radio_item', {
              search_radio_item_checked: active == item.active,
            })}
            onClick={() => {
              _handlerChangeItem(item.active);
            }}
          >
            {item.child}
          </div>
        );
      })}
    </div>
  );
});

interface IStateFilter {
  count: number;
  focus: boolean;
}
interface IStateSearchFilter {
  onClear: () => void;
  state: any;
  dispatch: any;
}

export function useSearchFiler() {
  const initialState: IStateFilter = { count: 0, focus: false };
  const reducer = (state: IStateFilter, action: any) => {
    switch (action.type) {
      case 'count':
        return { ...state, count: action.payload };
      case 'focus':
        return { ...state, focus: action.payload };
      default:
        return initialState;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState) as [IStateFilter, any];

  return [state, dispatch];
}

export const SearchFilter = React.memo((props: IStateSearchFilter) => {
  const { onClear, state, dispatch } = props;

  const _handlerClick = () => {
    dispatch({ type: 'focus', payload: !state.focus });
  };

  // 调用外部传入的clear让外部自己清空数据
  const _handlerClear = () => {
    onClear();
    dispatch({ type: 'count', payload: 0 });
    return false;
  };

  return (
    <Tooltip title={state.focus ? '收起筛选' : '筛选'}>
      <div
        className={classNames('center', 'search_item', {
          search_filter_box_active: state.focus,
        })}
      >
        <div className={classNames('center search_filter_box')} onClick={_handlerClick}>
          <Filter className="search-icon" size={20} />
        </div>
        {state.count > 0 && (
          <>
            <span className="count" onClick={_handlerClick}>
              {state.count}
            </span>
            <CloseOutlined className="close_btn" onClick={_handlerClear} />
          </>
        )}
      </div>
    </Tooltip>
  );
});

interface IStateSearchSort {
  onChange?: Function;
  selectKey: string;
  menu?: any[];
}

export const SearchSort = React.memo((props: IStateSearchSort) => {
  const { selectKey, onChange, menu } = props;

  const searchSortMenu = [
    {
      key: 'desc',
      label: (
        <div className="text-grey-6" onClick={() => onChange?.('desc')}>
          最新创建
        </div>
      ),
    },
    {
      key: 'asc',
      label: (
        <div
          className="text-grey-6"
          onClick={() => {
            onChange?.('asc');
          }}
        >
          最早创建
        </div>
      ),
    },
  ];

  const renderSelectTitle = () => {
    const item = (menu ?? searchSortMenu).find((element) => element.key == selectKey);
    return item?.label;
  };

  return (
    <div className="center">
      <Dropdown
        overlay={<Menu selectedKeys={[selectKey]} items={menu ?? searchSortMenu} />}
        trigger={['click']}
      >
        <div className="center cursor-pointer" onClick={(e) => e.preventDefault()}>
          <Sort className="search-icon" size={20} style={{ marginRight: '10px' }} />
          <span className="text-grey-6">{renderSelectTitle()}</span>
        </div>
      </Dropdown>
    </div>
  );
});

interface IStateSearchInput {
  onChange: Function;
  value: string;
  instantSearch?: boolean; // 即时搜索
  placeholder?: string;
}

export const SearchInput = React.memo((props: IStateSearchInput) => {
  const { instantSearch, placeholder } = props;
  const [searchInputModel, setSearchInputModel] = useState(false);
  const focusInput = useRef<any>();

  const lazyLoad = debounce((e) => {
    props.onChange(e.target.value);
  }, 1300);

  const _changeInputModel = () => {
    setSearchInputModel(true);

    setTimeout(() => {
      focusInput.current?.focus();
    }, 100);
  };

  const onSearch = () => {
    props.onChange?.(focusInput?.current?.input.value.trim() || '');
    // setSearchInputModel(false);
  };

  const handleAddKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (e?.keyCode === 13) {
      onSearch();
    }
  };

  return (
    <>
      {searchInputModel ? (
        <Input.Group
          compact
          style={
            instantSearch
              ? { marginRight: '10px', width: 240 }
              : { marginRight: '10px', width: 270, display: 'flex' }
          }
        >
          <Input
            ref={focusInput}
            defaultValue={props.value}
            prefix={instantSearch && <Search className="search-icon" size={20} />}
            onChange={(e) => {
              if (!e?.target?.value?.trim()) {
                props.onChange('');
                return;
              }
              if (!instantSearch) {
                return;
              }
              lazyLoad(e);
            }}
            onBlur={(e) => {
              // if (!instantSearch) {
              //   return;
              // }
              // 如果搜索输入有内容不能关闭
              if (e.target.value) {
                return;
              }
              setSearchInputModel(false);
            }}
            placeholder={placeholder || '请输入项目名称'}
            // style={{ width: 200 }}
            onKeyUp={handleAddKeyUp}
            allowClear
          />
          {!instantSearch && (
            <Button type="primary" icon={<Search color="#fff" />} onClick={onSearch} />
          )}
        </Input.Group>
      ) : (
        <div className="search_item search_filter_box center">
          <Search className="search-icon" onClick={_changeInputModel} />
        </div>
      )}
    </>
  );
});

interface IStateSite {
  onClick: (v: boolean) => void;
}

export const SearchSite = React.memo((props: IStateSite) => {
  const onCick = () => {
    props.onClick(true);
  };

  return (
    <div onClick={onCick} className={classNames('search_item', 'center', 'search_filter_box')}>
      <Site size={20} />
    </div>
  );
});
